export default {
    giftCards: [],
    giftCard: null,
    giftCardParams: null,
    giftCardDialog: false,
    giftCardDialogKey: null,
    giftCardSellDialog: false,
    giftCardSellDialogKey: null,
}
